import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AutorunComponent} from "@myshared/autorun.component";
import {PortformCustomAddress} from "../port-phonenumber.model";

@Component({
  selector: 'app-phonenumber-prepare-portform',
  templateUrl: 'phonenumber-prepare-portform.component.html',
  standalone: false,
})
export class PhonenumberPreparePortFormComponent extends AutorunComponent implements OnInit {
  @Input() companyName: string;
  @Output() selected: EventEmitter<{ customAddress?: PortformCustomAddress, name: string }> = new EventEmitter();

  public form: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.form = this.fb.group({
      companyName: [this.companyName || '', Validators.required],
      customAddress: false,
      street: ['', Validators.required],
      house_number: ['', Validators.required],
      zip: ['', Validators.required],
      city: ['', Validators.required]
    });
  }

  public onNext() {
    if (!this.isValid()) return;
    const useCustom = this.form.get('customAddress').value;

    this.selected.emit({
      customAddress: useCustom ? {
        street: this.form.get('street').value,
        house_number: this.form.get('house_number').value,
        zip: this.form.get('zip').value,
        city: this.form.get('city').value
      } : undefined,
      name: this.form.get('companyName').value
    });
  }

  public isValid(): boolean {
    const companyNameValid = this.form.get('companyName').valid;
    if (!this.form.get('customAddress').value) {
      return companyNameValid;
    }
    return companyNameValid &&
      this.form.get('street').valid &&
      this.form.get('house_number').valid &&
      this.form.get('zip').valid &&
      this.form.get('city').valid;
  }
}
